import { Mic } from 'lucide-react';

import { useHumanParticipants } from '../hooks/useHumanParticipants';

/**
 * Helpline-mode replacement for TileGrid. Renders remote participants
 * as rows with name + active-speaker indicator. The local participant
 * is filtered out. Speaking state comes from LiveKit's participant
 * event stream (isSpeaking updates via Vorbis voice activity detection
 * or equivalent when LiveKitRoom is connected).
 */
export function AudioParticipantList() {
  const allParticipants = useHumanParticipants();
  const remote = allParticipants.filter((p) => !p.isLocal);

  if (remote.length === 0) {
    return (
      <div className="text-body-sm flex h-full items-center justify-center p-6 text-neutral-400">
        No other participants yet.
      </div>
    );
  }

  return (
    <ul className="flex flex-col gap-2 p-6">
      {remote.map((p) => {
        const name = p.name ?? p.identity;
        const speaking = p.isSpeaking;
        return (
          <li
            key={p.identity}
            data-testid="participant-row"
            data-speaking={speaking ? 'true' : 'false'}
            className={[
              'flex items-center gap-3 rounded-md bg-neutral-800 p-3',
              speaking ? 'ring-primary-500 ring-2' : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            <Mic
              className={speaking ? 'text-primary-500 h-5 w-5' : 'h-5 w-5 text-neutral-500'}
              aria-hidden="true"
              strokeWidth={1.5}
            />
            <span className="text-body-sm text-neutral-100">{name}</span>
          </li>
        );
      })}
    </ul>
  );
}
